import { render, staticRenderFns } from "./html/EcOrdersList.html?vue&type=template&id=35939913&lang=html&external"
import script from "./js/EcOrdersList.js?vue&type=script&lang=js&external"
export * from "./js/EcOrdersList.js?vue&type=script&lang=js&external"
import style0 from "./scss/EcOrdersList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports